import React from 'react';

import { ResourcesFilterButton } from './resources-filter-button';
import { useFloorplanSectionFilter } from '../hooks/use-floorplan-section-filter.hook';

interface FloorplanFilterButtonProps {
  onClick: VoidFunction;
}

/**
 * The filter control while the map is on screen: the same button, counting the map's own filters.
 *
 * A wrapper rather than a flag on the button, so the section filter — and the placements query behind
 * it — is only read in the view that has a map to filter.
 */
export const FloorplanFilterButton = ({ onClick }: FloorplanFilterButtonProps): JSX.Element => {
  const { activeFilterCount } = useFloorplanSectionFilter();

  return <ResourcesFilterButton activeFilterCount={activeFilterCount} onClick={onClick} />;
};
